
import { deckService } from "@/services/deck.service";
import { Card, Deck } from "@/types";
import { defineComponent } from "@vue/runtime-core";
import { computed, onMounted, ref } from "vue";
import CardComponent from "./game/Card.vue";

export default defineComponent({
  name: "DeckBuilder",
  props: {
    deckId: {
      type: Number,
      required: true,
    },
  },
  components: {
    Card: CardComponent,
  },

  setup(props) {
    let deck = ref<Deck>({} as Deck);
    onMounted(async () => {
      deck.value = await deckService.getDeckWithCards(props.deckId);
    });
    const deckLength = computed(() => {
      let sum = 0;
      for (const card of deck.value.cards) {
        sum += card.count;
      }
      return sum;
    });

    let cards = ref<Card[]>([]);
    deckService.getAllUserCards().then((res) => (cards.value = res));

    const remainingCount = (card: Card): number => {
      if (typeof card.count === "undefined") card.count = 1;
      if (!deck.value) return 0;
      const deckCard = deck.value.cards.find((c) => c.id === card.id);
      if (!deckCard) return card.count;
      else return card.count - deckCard.count;
    };

    const addableToDeck = (card: Card) => {
      const deckCard = deck.value.cards.find((c) => c.id === card.id);
      return (
        remainingCount(card) > 0 &&
        (!card.gameClassId ||
          card.gameClassId === deck.value.monkey.gameClassId) &&
        (!deckCard || deckCard.count === 1)
      );
    };

    const removeCard = async (cardId: number) => {
      try {
        await deckService.removeCard({
          cardId,
          deckId: deck.value.id,
        });

        deck.value.cards = deck.value.cards
          .map((c) => {
            if (c.id === cardId) {
              c.count--;
              return c;
            } else return c;
          })
          .filter((c) => c.count > 0);
      } catch (e) {
        console.log(e);
      }
    };

    const addCard = async (card: Card) => {
      if (!addableToDeck(card)) return;
      if (deck.value.cards.length >= 20) return;
      try {
        await deckService.addCard({
          cardId: card.id,
          deckId: deck.value.id,
        });

        const deckCard = deck.value.cards.find((c) => c.id === card.id);
        if (!deckCard)
          deck.value.cards.push({
            ...card,
            count: 1,
          });
        else deckCard.count++;
      } catch (e) {
        console.log(e);
      }
    };

    return {
      deck,
      userCards: cards,
      remainingCount,
      addableToDeck,
      removeCard,
      addCard,
      deckLength,
    };
  },
});
